module.exports = __webpack_public_path__ + "static/media/img-1.80532f7b.png";